import { render, staticRenderFns } from "./AgentApplications.vue?vue&type=template&id=04a72d94"
import script from "./AgentApplications.vue?vue&type=script&lang=ts"
export * from "./AgentApplications.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports